import React, { useEffect, useState } from 'react';
import '../../assets/styles/HomePage.scss';
import { Button } from '../AntComponent';
import GarudaLogo from '../../assets/images/newlogo.svg';
import background from '../../assets/images/landingPage/background.jpg'
import dashImg from '../../assets/images/landingPage/bannerImage.png'
import cardOne from '../../assets/images/landingPage/cardOne.png'
import faded from '../../assets/images/landingPage/faded.jpg'
import collaboration from '../../assets/images/landingPage/collaboration.png'
import automation from '../../assets/images/landingPage/Automation.png'
import customization from '../../assets/images/landingPage/Customization.png'
import stringBg from '../../assets/images/landingPage/stringBg.png'
import footer from '../../assets/images/landingPage/footer.png'
import group from '../../assets/images/landingPage/groupImg.png'

export default function HomePage(){
    return(
    <>
        <div className='homePage'>
            <div className=  'row  firstRowParent ' >
                <div className="col firstRowContent pb-0"  >
                    <h1 className= 'pt-5 ps-5  col-10 firstPageRowHeading' >
                        Unleash the Potential of your Project
                    </h1>
                    <p className='col-11 mb-0 firstPageRowDescription'>Transform your decision-making with our advanced project management tools, optimized,
                    workflows, and data-driven insights.
                    </p>
                    <div className=" w-100">
                        <Button className='  my-3 homeDemoButton '>Get Demo</Button>
                    </div>
                </div>  
                <img src={dashImg} alt="dashboard" className="firstRowImage col"  width={300} height={300} />
            </div>
            <div className='row py-1 secondRowParent d-flex justify-content-center align-items-center'>
                <div className="col-5 d-flex secondCont flex-column align-items-center">
                    <h2 className="secondPageRowHeading ">More than just Project Management</h2>
                    <p className="secondPageRowDescription ">Revolutionise every aspect of your project 
                    from simple Gantt charts to complex Workflows & Automations</p>
                </div>   
            </div>
            <div className='row  thirdRowParent'>
                <div className="thirdHeadPart1 col-10  d-flex align-items-center">
                    <div className=' col-6'> 
                        <h2 className='h3part1 pb-1'>Organization</h2>
                        <h2 className='h3part2'>Expedite your projects with total Command.</h2>
                        <p className='h3part3'>
                            Plan and assign tasks in a few clicks, priortise them based on your custom needs, set project timelines,
                            track your team's progress, and manage their work all in one place, making it easier for everyone to stay well updated on the 
                            project. KoGaruda's clould-based platform lets your team share a single home for all their communication & file 
                            transfer
                        </p>
                    </div>
                </div>

                <div className="thirdHeadPart2   d-flex align-items-center">
                    <div className='card1 p-2'>
                        <img src={cardOne} alt="dashboard" className="cardImg col mb-1"  width={285} height={180} />
                        <div className='p-2 cardContent'>
                            <h4 className='card1Head'>Portfolio Models</h4>
                            <p className='card1Desp'>
                                A model portfolio is a collection of assets owned by the underlying investor and continually managed by professional investment managers.
                                Alternatively a Practice can adopt a do it yourself approach of using their own financial 
                            </p>
                            <Button className='col tryBtn mt-4'>Try Now</Button>
                        </div>
                    </div>
                    <div className='card2 cardDeux p-2 ms-5'>
                        <img src={faded} alt="dashboard" className="cardImg col mb-1"  width={285} height={180} />
                        <div className='p-2 cardContent faded-div'>
                            <h4 className='card2Head'>Portfolio Models</h4>
                            <p className='card2Desp '>
                                A model portfolio is a collection of assets owned by the underlying investor and continually managed by professional investment managers.
                                Alternatively a Practice can adopt a do it yourself approach of using their own financial 
                            </p>
                            <Button className='col tryBtn mt-4'>Try Now</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='cardContainer one fourthRowParent'>
                <div className='row CardInnerContainer d-flex justify-content-center align-items-center'>
                    <div className=" col-5 collaborationCont ps-4 pe-4" >
                        <h2 className='h3part1 one mb-0'>Collaboration</h2>
                        <h4 className='h3part2'>The solution your team will love to use </h4>
                        <p className='h3part3'>
                            To gain Transparency into the progress of your work, align your team with a solution they enjoy using.
                            KoGaruda's cloud-based platform let your team share a single home for all their communication & file transfer
                            and allow you to collaborate tool allows you to organize all communication by projects, tasks, data records, etc., 
                            making it easy to search for references
                        </p>
                    </div>
                    <div className="collaborationImgCont col-5 ms-4 ps-5" >
                        <img src={collaboration} alt="collaboration" className="collaborationImg col rounded"  width={600} height={350} />
                    </div>
                </div>
            </div>
            <div className='cardContainer two fifthRowParent'>
                <div className='row CardInnerContainer d-flex justify-content-center align-items-center'>
                    
                    <div className="collaborationImgCont col-5 ps-5" >
                        <img src={customization} alt="collaboration" className="collaborationImg col"  width={600} height={350} />
                    </div>
                    <div className=" col-5 collaborationCont ps-5 pe-5" >
                        <h2 className='h3part1 two mb-0'>Customization</h2>
                        <h4 className='h3part2'>End-to-end customizable and flexible </h4>
                        <p className='h3part3'>
                            With KoGaruda, you can manage a single project or as many as you want. Our built-in process management tools allow you 
                            to create structured workflows around your projects and the way they works for your team and clients. Our customs report creation
                            allows you to generate quick reports to track and analyse key metrics, leading to prompt and precise decisions. 
                        </p>
                    </div>
                </div>
            </div>
            <div className='sixthRowParent col  d-flex align-items-center'> 
                <div className='part1Cont col-5 me-4'>
                    <img src={GarudaLogo} className='p-1 mb-1 ' alt="login logo" width="65%"  />
                    <h3 className='h6part1 pb-1'>Innovative Solution for</h3>
                    <h2 className='h6part2 ps-1'>BETTER Future!</h2>
                    <p className='h6part3'>
                        To gain Transparency into the progress of your work, align your team with a solution they enjoy using.
                    </p>
                </div>
                <div className='ms-5 part2Cont'>
                    <Button className='  my-3 homeDemoButton '>Get Demo</Button>
                </div>
                <div>
                    <img src={group} alt="collaboration" className="groupImg col"  width={330} height={400} />
                </div>
            </div>
            <div className='cardContainer three seventhRowParent '> 
                <div className='row CardInnerContainer d-flex justify-content-center align-items-center'>
                    <div className="col-5 collaborationCont ps-4 pe-4" >
                        <h2 className='h3part1 three  mb-0'>Automation</h2>
                        <h4 className='h3part2'>Increase Role with automation</h4>
                        <p className='h3part3'>
                            With our unlimited automation recipes, you can automate all the regular tasks in the day-to-day process. From deadline reminders
                            to weekly notification to recieve overdue tasks. KoGaruda's automation can help you stay on top of your schedule. It increases your 
                            team's productivity and creativity by freeing up time.

                        </p>
                    </div>
                    <div className="collaborationImgCont col-5 ms-4 ps-5" >
                        <img src={automation} alt="collaboration" className="collaborationImg col"  width={600} height={350} />
                    </div>
                </div>
            </div>
            <div className='col eightRowParent end'>
                <img src={footer} alt="collaboration" className=" col w-100"   height={190} />
            </div>
        </div>
    </>
    )

}